<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5page2#chap1">I The Sunbonnet Myth</a></p>
<p class="toc1"><a href="#/6chap2#chap2">II “Peril Lay at Every Hand”</a></p>
<p class="toc1"><a href="#/7chap3#chap3">III The Army Girls</a></p>
<p class="toc1"><a href="#/8chap4#chap4">IV Beau Sabreur and His Lady Fair</a></p>
<p class="toc1"><a href="#/9chap5#chap5">V Some Ladies of Easy Virtue</a></p>
<p class="toc1"><a href="#/10chap6#chap6">VI “Many a Weary Mile”</a></p>
<p class="toc1"><a href="#/11chap7#chap7">VII A Lodging for the Night</a></p>
<p class="toc1"><a href="#/12chap8#chap8">VIII Vanity Conquers All</a></p>
<p class="toc1"><a href="#/13chap9#chap9">IX “A Little Light Diversion”</a></p>
<p class="toc1"><a href="#/14chap10#chap10">X Pink Tights and Red Velvet Skirts</a></p>
<p class="toc1"><a href="#/15chap11#chap11">XI A Home in the West</a></p>
<p class="toc1"><a href="#/16chap12#chap12">XII The Great Female Shortage</a></p>
<p class="toc1"><a href="#/17chap13#chap13">XIII Wyoming Tea Party</a></p>
<p class="toc1"><a href="#/18chap14#chap14">XIV Casting Off the Shackles</a></p>
<p class="toc1"><a href="#/19chap15#chap15">XV Schoolmarms and Maternal Forces</a></p>
<p class="toc1"><a href="#/20chap16#chap16">XVI Male Viewpoint</a></p>
<p class="toc1"><a href="#/21chap17#chap17">Image Gallery</a></p>
<p class="toc1"><a href="#/22chap18#chap18">Acknowledgments</a></p>
<p class="toc1"><a href="#/23chap19#chap19">Notes</a></p>
<p class="toc1"><a href="#/24chap20#chap20">Index</a></p>
<p class="toc1"><a href="#/25biography#biography">A Biography of Dee Brown</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?a0f3b298